import PropTypes from "prop-types";
import classnames from "classnames";
import { Button } from "basis";
import { SvgInline } from "../SvgInline/SvgInline";
import styles from "./info-block.module.scss";

function InfoBlock({
  iconName,
  hasRefreshButton = false,
  children,
  trackId,
  retry,
}) {
  const hasButton = hasRefreshButton || retry;

  return (
    <div
      className={classnames(styles.container, {
        [styles.containerWithButton]: hasButton,
      })}
    >
      <div
        className={classnames(styles.content, {
          [styles.contentWithButton]: hasButton,
        })}
        data-trackid={trackId}
      >
        {iconName && (
          <SvgInline className={styles.icon} name={iconName} size={32} />
        )}
        {children}
      </div>
      {hasButton && (
        <Button
          onClick={
            hasRefreshButton
              ? () => {
                  window.location.reload(true);
                }
              : retry
          }
        >
          {hasRefreshButton ? "Refresh page" : "Try again"}
        </Button>
      )}
    </div>
  );
}

InfoBlock.propTypes = {
  iconName: PropTypes.string,
  hasRefreshButton: PropTypes.bool,
  children: PropTypes.node.isRequired,
  trackId: PropTypes.string,
  retry: PropTypes.func,
};

export { InfoBlock };
